<div class="group-header cmn-flex row justify-between align-end" [ngClass]="{'cmn-error': error}">
  <div class="cmn-flex row align-center gutters-sm">
    <ng-container *ngTemplateOutlet="prefixActionRef"></ng-container>
    <span>{{header}}</span>
    <mat-icon *ngIf="toolTip"
              class="info-icon"
              fontSet="material-icons-outlined"
              [matTooltip]="toolTip">
      info
    </mat-icon>
  </div>
  <ng-container *ngTemplateOutlet="postfixActionRef"></ng-container>
  <button *ngIf="addText" mat-button color="primary" (click)="add.emit()" class="ignore-margin-v camelCase">
    <span>{{addText}}</span>
    <mat-icon>add</mat-icon>
  </button>
</div>
<div class="group-container cmn-flex column flex relative" [ngClass]="{'cmn-border': showBorder, 'cmn-error': error}">
  <ng-content></ng-content>
</div>
<ng-container *ngIf="staticSubsequentMessageContainer" >
  <div *ngIf="subsequentMessage" class="subsequent-message-container cmn-hint" [ngClass]="{'cmn-error': error}">
    <span *ngIf="isString(subsequentMessage); else subsequentMessageTemplate">{{subsequentMessage}}</span>
    <ng-template #subsequentMessageTemplate>
      <ng-container [ngTemplateOutlet]="subsequentMessage"></ng-container>
    </ng-template>
  </div>
</ng-container>
